<script setup lang="ts">
import shoppingCart from '@/assets/img/icon/shopping-cart.svg';
import AppTypography from '@/components/base/AppTypography.vue';
import { useCartStore } from '@/store/cart';

const isHydrated = ref(false);
const { carts } = storeToRefs(useCartStore());

const cartCountText = computed(() => {
  if (!isHydrated.value) return '';
  const len = carts.value.length;
  if (len === 0) return '';

  return len > 1 ? `${len} carts` : `${len} cart`;
});

onMounted(() => {
  isHydrated.value = true;
});
</script>

<template>
  <div class="d-flex align-center ga-2">
    <v-btn size="x-small" to="/carts" class="cart-button bg-primary" :height="32" :min-width="32">
      <v-img :src="shoppingCart" :height="16" :width="16" />
    </v-btn>
    <AppTypography v-if="cartCountText" type="subheadline-1">{{ cartCountText }}</AppTypography>
  </div>
</template>

<style lang="scss" scoped>
.cart-button {
  border-radius: 50% !important;
}
</style>
